import { Component, HostListener, Input, OnInit } from "@angular/core";
import { DomSanitizer, SafeResourceUrl } from "@angular/platform-browser";
import { DynamicDialogConfig, DynamicDialogRef } from "primeng/dynamicdialog";
import { PublicConfigService } from "src/app/shared/services/public.config.service";

@Component({
  selector: "app-tutorial-video-modal",
  templateUrl: "./tutorial-video-modal.component.html",
  styleUrls: ["./tutorial-video-modal.component.scss"],
})
export class TutorialVideoModalComponent implements OnInit {
  @Input() title: string;
  @Input() message: string;
  @Input() videoLink: string;
  @Input() btnOkText: string;
  @Input() btnCancelText: string;
  @Input() showAdditionalInfo = false;

  videoURL: SafeResourceUrl = null;

  constructor(
    public dialogRef: DynamicDialogRef,
    public config: DynamicDialogConfig,
    private sanitizer: DomSanitizer,
    private publicConfig: PublicConfigService
  ) {}

  ngOnInit() {
    this.title = this.config.data?.title;
    this.message = this.config.data?.message?.replace(
      /https:\/\/febaseurl/g,
      this.publicConfig.feBaseUrl
    );
    this.videoLink = this.config.data?.videoLink;
    this.btnOkText = this.config.data?.btnOkText;
    this.btnCancelText = this.config.data?.btnCancelText;
    this.showAdditionalInfo = this.config.data?.showAdditionalInfo;
    this.setVideoURL();
  }

  // close on navigation
  @HostListener('window:popstate', ['$event'])
  onPopState(event) {
    this.dismiss();
  }

  public decline() {
    this.dialogRef.close(false);
  }

  public accept() {
    this.dialogRef.close(true);
  }

  public dismiss() {
    this.dialogRef.close(false);
  }

  setVideoURL() {
    let link = this.videoLink;
    if (!link) {
      return;
    }
    if (link.includes("you")) {
      const url = new URL(link);
      const id = url?.searchParams?.get("v") || url?.pathname.replace("/", "");
      link = `https://www.youtube.com/embed/${id}`;
      this.videoURL = this.sanitizer.bypassSecurityTrustResourceUrl(link);
    }
  }
}
